import Segment from './Segment';
export { Props } from './Segment';
export default Segment;
